import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import { Login } from "../pages/Login";
import { useAuth } from "../hooks/use-auth";
import { ProjectIdContext } from '../contexts/Project/Project';
import ChooseProject from '../pages/afterLogin/chooseProject';
import { DashboardLayout } from '../containers/dashboard-layout';

function ProjectSelectGuard(props) {
    const { children } = props;
    const auth = useAuth();
    const location = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);

    const { ProjectID } = ProjectIdContext()

    if (ProjectID) {
        if (location.pathname !== requestedLocation) {
            setRequestedLocation(location.pathname);
        }

        return (
            <DashboardLayout />
        );
    }


    return (
        <div>{children}</div>
    );
}

export default ProjectSelectGuard;
